import { Sprint } from "../../types/Sprint";
import { SprintAction, SprintActionType } from "../actions/SprintAction";

const initialState: Sprint[] = [];

export const sprintReducer = (
  state = initialState,
  action: SprintAction,
): Sprint[] => {
  switch (action.type) {
    case SprintActionType.FETCH_SPRINTS:
      return action.data;
    case SprintActionType.FETCH_SPRINTS_PROJECTID:
      return action.data;
    case SprintActionType.ADD_SPRINT:
      return [...state, action.data];
    case SprintActionType.EDIT_SPRINT:
      return state.map((sp) => (sp.id === action.data.id ? action.data : sp));
    case SprintActionType.DELETE_SPRINT:
      return state.filter((sp) => sp.id !== action.data);
    default:
      return state;
  }
};
